import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

/**
 * TIMEOUT INTERCEPTOR
 * Fails requests that take too long, so slow APIs don't hang the UI forever.
 *
 * Default: 30 seconds
 * Override per request via `X-Timeout` header (milliseconds).
 *   - Heavy exports / PDF generation: X-Timeout: 120000
 *   - File uploads:                   X-Timeout: 300000
 */
@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  private readonly DEFAULT_TIMEOUT_MS = 30000;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const header = req.headers.get('X-Timeout');
    const ms = header ? Number(header) : this.DEFAULT_TIMEOUT_MS;

    let finalReq = req;
    if (header) {
      finalReq = req.clone({ headers: req.headers.delete('X-Timeout') });
    }

    return next.handle(finalReq).pipe(timeout(ms > 0 ? ms : this.DEFAULT_TIMEOUT_MS));
  }
}
